module.exports = __WEBPACK_EXTERNAL_MODULE_6__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
 ** module id = 6
 ** module chunks = 0
 **/